<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About The Author</h1>
<p>After thirty years of law practice, Mary E. Martin embarked on her writing career. Inspired by her experiences in the law, she wrote the highly acclaimed <em>Osgoode Trilogy</em> about a lawyer named Harry Jenkins. Turning to her greatest passion, art, she then began <em>The Trilogy of Remembrance,</em> featuring a visionary landscape artist, Alexander Wainwright. <em>The Wondrous Apothecary</em> is a natural and exciting addition to that trilogy. She lives in Toronto with her husband. They have three children and three grandchildren.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?554be9a2